import React from "react";
import './ErrorPopup.scss';

interface ErrorInterface {
    handleClose: () => void
};

export default function ErrorPopup ({ handleClose }: ErrorInterface) {
    const handleContactUs = () => {
        window.location.href = "mailto:sales@belltreegroup.co.uk";
        handleClose && handleClose();
    }
    return (
        <div className="error-main-css">
            <div className="modal-popup">
                <span className="title-css">Error Notification</span>

                <div className="content-css"> Your current subscription does not include this dataset. Please contact us today to dicuss upgrading.</div>
                <div className="footer">
                    <button className="button-css" onClick={() => handleClose()}>Cancel</button>
                    <button
                        className="button-css"
                        onClick={handleContactUs}
                    >
                        Contact Us
                    </button>
                </div>
            </div>
        </div>
    )
}